import React, { Component } from 'react';
import NotificationPopoverCell from './NotificationPopoverCell.js';

import './NotificationsPopover.css';

class NotificationsPopover extends Component {
  render() {
    const { notifications, visible } = this.props;
    let classNames = ['TetheredPopover', 'NotificationsPopover'];
    if (visible) {
      classNames.push('TetheredPopover--visible');
    }

    let notificationCells = notifications.map((notification) => {
      return <NotificationPopoverCell
        key={notification.id}
        notification={notification}
        onAccept={this.props.acceptNotification}
        onDecline={this.props.declineNotification} />;
    });

    if (!notificationCells.length) {
      notificationCells = <p className="text-help text-help--light">No new notifications! Any room invites or friend requests you receive will show up here.</p>;
    }

    return (
      <div className={classNames.join(' ')}>
        <ul className="NotificationList">
          {notificationCells}
        </ul>
      </div>
    );
  }
}

NotificationsPopover.defaultProps = {
  notifications: []
};

export default NotificationsPopover;



// WEBPACK FOOTER //
// ./src/components/NotificationsPopover.js